export const DIRECT_X_OPTIONS = [
  { value: 9, label: 'DirectX 9' },
  { value: 10, label: 'DirectX 10' },
  { value: 11, label: 'DirectX 11' },
  { value: 12, label: 'DirectX 12' },
]

export const HARDWARE_TYPES = {
  CPU: 0,
  GPU: 1,
}

export const emptySystemRequirement = () => ({
  x32: false,
  x64: false,
  requirement: '',
  os: [],
  directX: [],
  cpu: [],
  gpu: [],
  vRam: '',
  ram: '',
  storage: '',
})

const parseHardwareOptions = (ids, titles, legacyId, legacyTitle) => {
  if (Array.isArray(ids) && ids.length) {
    return ids.map((id, index) => ({
      value: id,
      label: (Array.isArray(titles) ? titles[index] : '') || String(id),
    }))
  }

  if (legacyId != null) {
    return [{ value: legacyId, label: legacyTitle || String(legacyId) }]
  }

  return []
}

export const parseSystemRequirement = (data) => {
  if (!data) return emptySystemRequirement()

  return {
    x32: !!data.x32,
    x64: !!data.x64,
    requirement: data.requirement || '',
    os: data.os || [],
    directX: data.directX || [],
    cpu: parseHardwareOptions(
      data.cpuHardwareIds,
      data.cpuHardwareTitles,
      data.cpuHardwareId,
      data.cpuHardwareTitle
    ),
    gpu: parseHardwareOptions(
      data.gpuHardwareIds,
      data.gpuHardwareTitles,
      data.gpuHardwareId,
      data.gpuHardwareTitle
    ),
    vRam: data.vRam ?? '',
    ram: data.ram ?? '',
    storage: data.storage ?? '',
  }
}

export const buildSystemRequirementPayload = (state) => {
  const hasData =
    state.x32 ||
    state.x64 ||
    state.requirement?.trim() ||
    state.os?.length ||
    state.directX?.length ||
    state.cpu?.length ||
    state.gpu?.length ||
    state.vRam !== '' ||
    state.ram !== '' ||
    state.storage !== ''

  if (!hasData) return null

  const vRam = state.vRam !== '' ? Number(state.vRam) : null
  const ram = state.ram !== '' ? Number(state.ram) : null
  const storage = state.storage !== '' ? Number(state.storage) : null

  const payload = {
    x32: state.x32,
    x64: state.x64,
    requirement: state.requirement?.trim() || null,
    os: state.os?.length ? state.os : [],
    directX: state.directX?.length ? state.directX : [],
    cpuHardwareIds: state.cpu?.length ? state.cpu.map((item) => item.value) : [],
    gpuHardwareIds: state.gpu?.length ? state.gpu.map((item) => item.value) : [],
    vRam: Number.isFinite(vRam) ? vRam : null,
    ram: Number.isFinite(ram) ? ram : null,
    storage: Number.isFinite(storage) ? storage : null,
  }

  return payload
}

export const hasSystemRequirementData = (data) => {
  if (!data) return false

  return !!(
    data.x32 ||
    data.x64 ||
    data.requirement?.trim?.() ||
    data.os?.length ||
    data.directX?.length ||
    data.cpuHardwareIds?.length ||
    data.cpuHardwareTitles?.length ||
    data.cpuHardwareId != null ||
    data.cpuHardwareTitle ||
    data.gpuHardwareIds?.length ||
    data.gpuHardwareTitles?.length ||
    data.gpuHardwareId != null ||
    data.gpuHardwareTitle ||
    data.vRam != null ||
    data.ram != null ||
    data.storage != null
  )
}

export const formatOsDisplay = (osIds, osOptions = []) => {
  if (!osIds?.length) return null

  const titles = osIds
    .map((id) => osOptions.find((option) => option.value === id)?.label)
    .filter(Boolean)

  return titles.length ? titles.join(', ') : null
}

export const formatDirectXDisplay = (directX) => {
  if (!directX?.length) return null

  return directX.map((version) => `version ${version}`).join(', ')
}

export const formatHardwareDisplay = (
  titles = [],
  legacyTitle = null,
  ids = [],
  legacyId = null
) => {
  const values = Array.isArray(titles) ? titles.filter(Boolean) : []

  if (values.length) {
    return values.join(', ')
  }

  if (legacyTitle?.trim()) {
    return legacyTitle.trim()
  }

  if (Array.isArray(ids) && ids.length) {
    return ids.join(', ')
  }

  if (legacyId != null) {
    return String(legacyId)
  }

  return null
}

export const formatStorageDisplay = (value) => {
  if (value == null || value === '') return null

  const num = Number(value)
  if (!Number.isFinite(num)) return null

  return `${Number.isInteger(num) ? num : num}GB`
}
